import Vue from 'vue'
import Router from 'vue-router'
import routerLists from './routerLists';
import vote from '@/components/pages/vote'
import privacy from '@/components/pages/privacy/privacy'
import terms from '@/components/pages/privacy/terms'
import privacyNew from '@/components/pages/privacy/privacyNew'
import termsNew from '@/components/pages/privacy/termsNew'
import thirdlist from '@/components/pages/privacy/thirdlist'

Vue.use(Router)
/** 避免重复点击报错 */
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
export default new Router({
  mode: 'history',
  routes: [...routerLists, {
    path: '/vote',
    label: '金翎奖投票',
    key: 'vote',
    component: vote
  },
  {
    path: '/privacy',
    label: '隐私政策',
    key: 'privacy',
    component: privacyNew
  },
  {
    path: '/terms',
    label: '用户协议',
    key: 'terms',
    component: termsNew
  },{
    path: '/privacy/agreementId=E20200101',
    label: '隐私政策',
    key: 'privacy',
    component: privacy
  },
  {
    path: '/terms/agreementId=E20200101',
    label: '用户协议',
    key: 'terms',
    component: terms
  },{
    path: '/thirdlist',
    label: '第三方服务共享清单',
    key: 'thirdlist',
    component: thirdlist
  }]
})



// WEBPACK FOOTER //
// ./src/router/index.js